var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"d-flex justify-center align-center",staticStyle:{"background-color":"#fff"},attrs:{"fluid":"","fill-height":""}},[_c('v-img',{attrs:{"src":require("@/assets/connect_stop.png"),"max-width":"50vw","max-height":"50vh","contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }